import React, { useState } from 'react';
import { Typography, Box, IconButton, Grid, Button } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
// import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import axiosInstance from '../../../utils/axios';
import { Wrapper } from '../../../sections/@dashboard/Trade/watchlist/BuyScriptDrawer';

const RestoreTradeodal = ({ trade, isOpen, onClose, onUpdateSuccess }) => {
  //   const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleDeleteTrade = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.put(`/trade/reopen-close-trade/${trade._id}`);
      enqueueSnackbar(response.data.message, { variant: 'success' });
      setIsLoading(false);
      onUpdateSuccess();
      onClose();
    } catch (err) {
      setIsLoading(false);
      onClose();
      enqueueSnackbar(err.message, { variant: 'error' });
    }
  };

  return (
    <Wrapper
      open={isOpen}
      onClose={onClose}
      children={
        <Box width={{ xs: '100%', sm: '350px' }} marginX={'auto'}>
          <IconButton sx={{ position: 'absolute', top: 0, right: 0 }} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h4" textAlign="center" pb={2}>
            {`Restore ${trade.side === 'BUY' ? 'SELL' : 'BUY'}`}
          </Typography>
          <Typography variant="body1" textAlign="center" pb={2}>
            Are you sure you want to Restore this trade?
          </Typography>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <LoadingButton
                variant="contained"
                fullWidth
                size="large"
                onClick={handleDeleteTrade}
                color="primary"
                loading={isLoading}
              >
                Yes
              </LoadingButton>
            </Grid>
            <Grid item xs={6}>
              <Button variant="outlined" fullWidth size="large" onClick={onClose}>
                No
              </Button>
            </Grid>
          </Grid>
        </Box>
      }
    />
  );
};

RestoreTradeodal.propTypes = {
  trade: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdateSuccess: PropTypes.func,
};

export default RestoreTradeodal;
